import { EventInvitationService } from './../services/event-invitation.service';
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { EventInvitationActions, EventInvitationResetActions } from '../actions/event-invitation.actions';
import { EventInvitation } from '@features/event-invitation/utils/models/event-invitation.model';

@Injectable()
export class EventInvitationEffects {
  private readonly eventInvitationService = inject(EventInvitationService);
  private readonly actions$ = inject(Actions);

  getEventInvitation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EventInvitationActions.getEventInvitation, EventInvitationResetActions.cancelEventInvitationActions),
      switchMap((action) =>
        action.type === EventInvitationResetActions.cancelEventInvitationActions.type
          ? of(EventInvitationResetActions.cancelEventInvitationActionsSuccess())
          : this.eventInvitationService.getEventInvitation(action.hash).pipe(
              map((response: HttpResponse<EventInvitation>) =>
                EventInvitationActions.getEventInvitationSuccess({ invitation: response.message })
              ),
              catchError((error: HttpError) => of(EventInvitationActions.getEventInvitationFailure({ error })))
            )
      )
    );
  });
}
